import valorantNeedHelpBackground from "@assets/valorant-need-help-banner.png";
import NeedHelpBanner from "@core-components/help-banner/NeedHelpBanner";

const ValorantNeedHelpBanner = () => {
  return <NeedHelpBanner background={valorantNeedHelpBackground} />;
};

export default ValorantNeedHelpBanner;
